import { IDeleteAssistenciaArquivoDiversoUseCase } from "../../../presentation/useCases/delete/delete_assistencia_arquivo_diverso_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeleteAssistenciaArquivoDiversoUseCase
 */

export class DeleteAssistenciaArquivoDiversoUseCase implements IDeleteAssistenciaArquivoDiversoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async deleteAssistenciaArquivoDiverso(
    idAssistenciaTecnica: number,
    idAssistenciaArquivo: number,
  ): Promise<void> {
    await this.repository.deleteAssistenciaArquivoDiverso(idAssistenciaTecnica, idAssistenciaArquivo);
  }
}
